import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  CardActions,
  Box,
  LinearProgress,
  Tooltip,
} from "@mui/material";
import EventRoundedIcon from "@mui/icons-material/EventRounded";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import MapIcon from "@mui/icons-material/Map";

const CustomCard = ({ title, content, onAction1, onAction2, isSubmitting }) => {
  return (
    <Card
      sx={{
        width: 260,
        backgroundColor: "#ffffff",
        borderRadius: 3,
        boxShadow: "0px 2px 12px rgba(0,0,0,0.08)",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        transition: "transform 0.18s ease, box-shadow 0.18s ease",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0px 8px 24px rgba(31, 97, 141, 0.18)",
        },
        overflow: "hidden",
        position: "relative",
      }}
    >
      {/* Barra superior de color */}
      <Box sx={{ height: 6, backgroundColor: "#1F618D", width: "100%" }} />

      <CardContent sx={{ pt: 3, pb: 1 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mb: 1.5,
          }}
        >
          <Box
            sx={{
              backgroundColor: "#EAF4FB",
              borderRadius: "50%",
              p: 1.2,
              display: "flex",
            }}
          >
            <MapIcon sx={{ color: "#1F618D", fontSize: 28 }} />
          </Box>
        </Box>
        <Typography
          variant="h6"
          component="div"
          sx={{
            fontWeight: 700,
            color: "#1a2b3c",
            fontSize: "1rem",
            lineHeight: 1.3,
            mb: content ? 0.5 : 0,
          }}
        >
          {title}
        </Typography>
        {content && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {content}
          </Typography>
        )}
      </CardContent>

      <CardActions sx={{ justifyContent: "center", gap: 1, pb: 2, flexWrap: "wrap" }}>
        <Tooltip title={isSubmitting ? "Procesando..." : "Subir archivo de padrón"}>
          <span>
            <Button
              variant="contained"
              size="small"
              startIcon={<CloudUploadIcon />}
              disabled={isSubmitting}
              onClick={onAction1}
              sx={{
                backgroundColor: "#1F618D",
                textTransform: "none",
                fontWeight: 600,
                borderRadius: 2,
                "&:hover": { backgroundColor: "#154360" },
              }}
            >
              Subir Archivo
            </Button>
          </span>
        </Tooltip>
        {onAction2 && (
          <Button
            variant="outlined"
            size="small"
            startIcon={<EventRoundedIcon />}
            onClick={onAction2}
            sx={{
              borderColor: "#E67E22",
              color: "#E67E22",
              textTransform: "none",
              fontWeight: 600,
              borderRadius: 2,
              "&:hover": {
                backgroundColor: "#FEF9E7",
                borderColor: "#CA6F1E",
                color: "#CA6F1E",
              },
            }}
          >
            Ver Fechas
          </Button>
        )}
      </CardActions>

      {isSubmitting && (
        <LinearProgress
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: 3,
          }}
        />
      )}
    </Card>
  );
};

export default CustomCard;
